/**
 * ApplyForm.js
 *
 * Setup application form functionality
 *
 * @param $ jquery
 */
const ApplyForm = ( $ )=> {
	'use strict';

	const send = (data) => {

		const url = main_script.ajaxurl; // eslint-disable-line

		$.post(url, data, function (response) {
			if (response.success) {
				$("#message-response-area").addClass("msg-success").removeClass("msg-error");
			} else {
				$("#message-response-area").addClass("msg-error");
			}

			const formFields = Object.keys (response.data);

			formFields.forEach(field => {
				$(`#${field}-response-area`).html(response.data[field]);
			});
		});
	}

	const init = () => {

		$("#submit-apply").click(function (e) {
			e.preventDefault();

			const fromFieldNames = [
				"organization",
				"name",
				"email",
				"phone",
				"organization-url",
				"help",
				"organization-mission",
				"challenges",
				"agreement"
			];

			fromFieldNames.forEach(field => {
				$(`#${field}-response-area`).html("");
			})

			let grecaptcha = window.grecaptcha;

			grecaptcha
				.execute("6LfTQ9IZAAAAAGw6ZxxA--bloJA2NeuXTCOSNdEs", {
					action: "apply",
				})
				.then((token) => {
					let recaptchaResponse = document.getElementById("recaptcha_response");
					recaptchaResponse.value = token;
					const ajaxFormData = $("#apply-form").serialize();
					send(ajaxFormData);
				});
		});
	}

	init();

};

export default ApplyForm;
